import * as t from "io-ts";
const rowSnapshotT = t.record(t.string, t.unknown);
export const adminRouteHistoryEntryT = t.strict({
    historyId: t.string,
    operation: t.union([t.literal("INSERT"), t.literal("UPDATE"), t.literal("DELETE")]),
    updatedAt: t.string,
    traceId: t.union([t.string, t.null]),
    data: t.union([rowSnapshotT, t.null]),
});
export const adminRouteCargoHistoryEntryT = t.strict({
    historyId: t.string,
    cargoId: t.string,
    updatedAt: t.string,
    data: t.union([rowSnapshotT, t.null]),
});
export const adminRouteStopHistoryEntryT = t.strict({
    historyId: t.string,
    stopId: t.string,
    updatedAt: t.string,
    data: t.union([rowSnapshotT, t.null]),
});
export const adminRouteInspectT = t.strict({
    current: t.strict({
        id: t.string,
        ref: t.union([t.string, t.null]),
        exists: t.boolean,
    }),
    liveRoute: t.union([rowSnapshotT, t.null]),
    routeHistory: t.array(adminRouteHistoryEntryT),
    cargoHistory: t.array(adminRouteCargoHistoryEntryT),
    liveCargos: t.array(rowSnapshotT),
    stopHistory: t.array(adminRouteStopHistoryEntryT),
    liveStops: t.array(rowSnapshotT),
    names: t.strict({
        trailers: t.record(t.string, t.string),
        teams: t.record(t.string, t.string),
        drivers: t.record(t.string, t.string),
        users: t.record(t.string, t.string),
        clients: t.record(t.string, t.string),
    }),
    trackingStartedAt: t.strict({
        routes: t.union([t.string, t.null]),
        stops: t.union([t.string, t.null]),
    }),
});
//# sourceMappingURL=admin-route-inspect.js.map